module.exports = __webpack_public_path__ + "img/bag.16d32414.svg";